import { computed, ref } from '@vue/composition-api';

const loading = ref(false);

export default function useValidation() {
  const errorMessage = ref(null);
  const errors = ref({});
  const localLoading = ref(false);

  const hasErrors = computed(() => Object.keys(errors.value).length > 0 || errorMessage.value);

  function clear() {
    errorMessage.value = null;
    errors.value = {};
  }

  function setLoading(val) {
    localLoading.value = val;
    loading.value = val;
  }

  async function withApiErrorHandling(callback, onApiErrorCallback) {
    clear();
    setLoading(true);
    try {
      await callback.call();
    } catch (e) {
      if (e.name !== 'ApiError') {
        throw e;
      }
      errorMessage.value = e.message;
      if (typeof onApiErrorCallback === 'function') {
        await onApiErrorCallback(e);
        return;
      }
      throw e;
    } finally {
      setLoading(false);
    }
  }

  async function withValidationHandling(
    callback,
  ) {
    await withApiErrorHandling(callback, (e) => {
      errors.value = e.errors;
    });
    return null;
  }

  async function withLoading(callback, _, ...args) {
    setLoading(true);

    try {
      await callback.call(...args);
    } finally {
      setLoading(false);
    }
  }

  function clearError(key) {
    errors.value[key] = null;
  }

  return {
    errorMessage,
    errors,
    loading: computed(() => loading.value),
    localLoading: computed(() => localLoading.value),
    hasErrors,
    hasErrorMessageOnly: computed(() => !hasErrors.value && errorMessage.value !== null),
    withValidationHandling,
    withLoading,
    withApiErrorHandling,
    clearError,
  };
}
